export const NESTOR_URL = process.env.REACT_APP_NESTOR_URL;
export const TEMP_NESTOR_URL = process.env.REACT_APP_TEMP_NESTOR_URL;
